export default {
      id: "Icon--badgeSeen-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--badgeSeen",
      toString: function () {
        return this.url;
      }
    }